/**
 * Scroll to top mixin
 * 用於處理頁面載入時滾動到頂部的問題
 * 特別適用於有複雜佈局（地圖、絕對定位元素等）的頁面
 */
export const scrollToTopMixin = {
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      // 使用 nextTick 確保 DOM 完全渲染後再滾動
      this.$nextTick(() => {
        // 雙重確保：先用 nextTick，再用 setTimeout
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
          });
        }, 0);
      });
    }
  }
};

/**
 * 強制滾動到頂部的 mixin（不使用平滑滾動）
 * 適用於需要立即滾動的情況，特別是複雜佈局頁面
 */
export const forceScrollToTopMixin = {
  mounted() {
    this.forceScrollToTop();
  },
  methods: {
    forceScrollToTop() {
      // 使用多層 nextTick 和 setTimeout 確保在最合適的時機執行滾動
      this.$nextTick(() => {
        setTimeout(() => {
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
        }, 50);
      });
    }
  }
};
